const sceneMap = {
  "/remove-background": "saas-rmbg",
  "/background-removal-api": "saas-rmbg",

  "/unblur-image-portrait": "saas-enhance",
  "/photo-enhancer": "saas-enhance",
  "/image-enlarger": "saas-enhance",
  "/photo-enhancer-api": "saas-enhance",

  "/remove-unwanted-object": "saas-watermark",
  "/remove-objects-api": "saas-watermark",

  "/compress-image": "saas-compress",
  "/image-compression-api": "saas-compress",

  "/photo-colorizer": "saas-colorizer",
  "/photo-colorization-api": "saas-colorizer",

  "/crop-image": "saas-crop",

  "/remove-background-id-photo": "saas-idcard",
};

function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

setTimeout(() => {
  let { pathname } = window.location;
  const apptype = getQueryVariable("apptype");

  if (window.wx_hawkeye) {
    // 如果第三位是 / 那么就是多语言
    pathname = pathname[3] === "/" ? pathname.slice(3) : pathname;

    if (apptype) {
      return window.wx_hawkeye.set_apptype(apptype);
    } else if (sceneMap[pathname]) {
      return window.wx_hawkeye.set_apptype(sceneMap[pathname]);
    }
  }
}, 300);
